import React from 'react';
import Stack from '@mui/material/Stack';
import CounselingCenterStatistics from './counselingCenter/CounselingCenterStatistics';

import InterventionCenterStatistics from './interventionCenter/InterventionCenterStatistics';
import InterventionCenterGovStatistics from './interventionCenterGov/InterventionCenterGovStatistics';
import type { FhbfStatisticType } from '../../common/types/statistics/fhbfStatistics';
import type { StatisticsFilter } from '../../common/types/statistics/statistics';

type Props = {
  statistic: FhbfStatisticType | null | undefined;
  statisticFilter: StatisticsFilter;
};

function Statistic({ statistic, statisticFilter }: Props) {
  if (statistic == null) return null;

  return (
    <Stack spacing={4} sx={{ display: 'block' }}>
      {statistic.type === 'counselingCenter' && <CounselingCenterStatistics statistics={statistic} />}
      {statistic.type === 'interventionCenter' && <InterventionCenterStatistics statistics={statistic} />}
      {statistic.type === 'interventionCenterGov' && (
        <InterventionCenterGovStatistics statistics={statistic} statisticFilter={statisticFilter} />
      )}
    </Stack>
  );
}

export default Statistic;
